import { ApolloProvider } from '@apollo/client';
import { createTheme, NextUIProvider } from '@nextui-org/react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

import client from '../apollo-client';

import { AnimatePresence } from 'framer-motion';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import '../styles/globals.css';
import '../styles/transition.css';

const theme = createTheme({
  type: 'light', // it could be "light" or "dark"
  theme: {
    colors: {
      selection: '#B4D5FE',
      // primary: '#4ADE7B',
      // secondaryLightContrast: '#F9CB80',
      // error: '#FCC5D8',
      // default: '#F90',
      // brand colors
    },
  },
});

const darkTheme = createTheme({
  type: 'dark',
  theme: {
    colors: {
      selection: '#3399FF',
      // text: '#F9CB80',
    },
  },
});

export default function MyApp({ Component, pageProps }: any) {
  const router = useRouter();
  const [clickedLink, setClickedLink] = useState(false);

  const [initialLoad, setInitialLoad] = useState(true);
  const [browserNavigated, setBrowserNavigated] = useState(false);

  if (typeof history !== 'undefined') {
    history.scrollRestoration = 'manual';
  }

  useEffect(() => {
    setBrowserNavigated(false);
    router.beforePopState(({ as, options }) => {
      // todo: need to implement custom scrolling logic instead of this
      options.scroll = false;
      if (as !== router.asPath) {
        // Will run when leaving the current page; on back/forward actions
        // Add your logic here, like toggling the modal state
        setBrowserNavigated(true);
      } else {
        // Will run when navigating to a new page
        setClickedLink(true);
      }
      return true;
    });

    return () => {
      router.beforePopState(() => true);
    };
  }, [router]); // Add any state variables to dependencies array if needed.

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme={'system'}
      value={{
        light: theme.className,
        dark: darkTheme.className,
      }}
    >
      <NextUIProvider>
        <ApolloProvider client={client}>
          <AnimatePresence
            initial={false}
            mode="wait"
            onExitComplete={() => {
              setInitialLoad(false);
              if (typeof window !== 'undefined') {
                if (!browserNavigated) {
                  window.scrollTo({ top: 0 });
                  setBrowserNavigated(false);
                }
              }
            }}
          >
            <Component {...pageProps} key={router.asPath} initialLoad={initialLoad} />
          </AnimatePresence>
        </ApolloProvider>
      </NextUIProvider>
    </NextThemesProvider>
  );
}
